module.exports = __webpack_public_path__ + "img/measure_clear.a5978a9e.png";